var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusStackedboxes = function SvgPlusStackedboxes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_2",
    viewBox: "0 0 184.88 184"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-width:4px}.cls-1{stroke:#007533;stroke-linejoin:round}.cls-2{stroke:#00db33;stroke-miterlimit:10}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.9 2v22.66c0 1.68 1.37 3.05 3.05 3.05h19.61c1.68 0 3.05-1.37 3.05-3.05V2",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.29 2h50.94c7.44 0 13.48 6.09 13.48 13.61v49.93c0 7.51-6.03 13.61-13.48 13.61H66.29c-7.44 0-13.48-6.09-13.48-13.61V15.61C52.81 8.1 58.84 2 66.29 2Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.08 104.86v22.66c0 1.68 1.37 3.05 3.05 3.05h19.61c1.68 0 3.05-1.37 3.05-3.05v-22.66",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.46 104.86h50.94c7.44 0 13.48 6.09 13.48 13.61v49.93c0 7.51-6.03 13.61-13.48 13.61h-50.94c-7.44 0-13.48-6.09-13.48-13.61v-49.93c0-7.51 6.03-13.61 13.48-13.61Z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.09 104.86v22.66c0 1.68 1.37 3.05 3.05 3.05h19.61c1.68 0 3.05-1.37 3.05-3.05v-22.66",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.48 104.86h50.94c7.44 0 13.48 6.09 13.48 13.61v49.93c0 7.51-6.03 13.61-13.48 13.61H15.48C8.04 182.01 2 175.92 2 168.4v-49.93c0-7.51 6.03-13.61 13.48-13.61Z",
    className: "cls-1"
  }))));
};
export default SvgPlusStackedboxes;